<template>
    <v-group
            :config="groupConfig"
            @mouseover="hover(true)"
            @mouseout="hover(false)"
    >
        <v-line
                :config="hemConfig"
                @dblclick="changeFlip"
        ></v-line>

        <HemSize
                :size="size"
                :connectionPoint="connectionPoint"
                :angle="angle"
                :flip="flip"
                :color="color"
                @edit="openEditPopup"
        ></HemSize>
    </v-group>
</template>

<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
    import HemSize from "./HemSize";

    export default {
        name: "Hem",

        components: {
            HemSize
        },

        props: [
            'id',
            'type',
            'lineColor',
            'lineColorHover',
            'size',
            'flip',
            'isHover',
        ],

        data() {
            return {
                isHovered: false,
            }
        },

        computed: {
            ...mapState('editor', [
                'drawingState',
            ]),

            ...mapGetters('editor', [
                'getPointById',
                'hemPreviousPoint',
            ]),

            ...mapGetters('angles', [
                'getLineAngle',
            ]),

            connectionPoint() {
                return this.getPointById(this.id);
            },

            prevPoint() {
                return this.hemPreviousPoint(this.id);
            },

            angle() {
                const p1 = this.connectionPoint;
                const p2 = this.prevPoint;

                return this.getLineAngle(p1, p2);
            },

            groupConfig() {
                let {x, y} = this.connectionPoint;
                let scaleY = this.flip ? -1 : 1;

                return {
                    x,
                    y,
                    rotation: this.angle,
                    scaleY,
                }
            },

            openHemPoints() {
                const lapWidth = 20;
                const borderWidth = 8;

                let points = [
                    0, 0,
                    0, borderWidth,
                    -lapWidth, borderWidth,
                ];

                return points;
            },

            closeHemPoints() {
                const lapWidth = 24;
                const borderWidth = 8;

                let points = [
                    0, 0,
                    0, borderWidth,
                    -lapWidth, 0,
                ];

                return points;
            },

            color() {
                let hovered = !this.drawingState && this.isHover;

                return hovered ? this.lineColorHover : this.lineColor;
            },

            hemConfig() {
                let points = this.type === 'openHem' ? this.openHemPoints : this.closeHemPoints;

                return {
                    name: 'hem',
                    points,
                    stroke: this.color,
                    strokeWidth: 3,
                    lineCap: 'round',
                    lineJoin: 'round',
                    hitFunc: function (context) {
                        context.beginPath();
                        context.rect(2, -2, -25, 12);
                        context.closePath();
                        context.fillStrokeShape(this);
                    },
                    listening: true,
                }
            },

        },

        methods: {
            ...mapMutations('editor', [
                'setHemFlip',
                'setHemIsHover',
            ]),

            ...mapActions('editPopup', [
                'openHemEditPopup',
            ]),

            changeFlip() {
                let flip = !this.flip;

                this.setHemFlip({point: this.connectionPoint, flip});
            },

            openEditPopup() {
                const hemId = this.id;

                this.openHemEditPopup(hemId);
            },

            hover(isHover) {
                this.setHemIsHover({point: this.connectionPoint, isHover})
            },

        },

    }
</script>

<style scoped>

</style>